@if (patchingItemForm !== null && replacingItem !== null) {
  <h3 mat-dialog-title i18n>Editing {{ replacingItem.name }}</h3>
  <mat-dialog-content>
    <form>
      @if (patchingItemForm.get('name')) {
        <eas-editor-booking-item-name-form
          [parentFormGroup]="patchingItemForm"
          [itemNameForm]="getPatchingItemFormControl('name')">
        </eas-editor-booking-item-name-form>
      }
      @if (patchingItemForm.get('canBeBooked') && patchingItemForm.get('hideSpecificBookingSettings')) {
        <eas-editor-booking-item-booking-form
          [parentFormGroup]="patchingItemForm"
          [replacingItem]="replacingItem"
          [itemCanBeBookedForm]="getPatchingItemFormControl('canBeBooked')"
          [itemHideSpecificBookingSettingsForm]="getPatchingItemFormControl('hideSpecificBookingSettings')">
        </eas-editor-booking-item-booking-form>
      }
      @if (patchingItemForm.get('bundle')) {
        <eas-editor-booking-item-bundle-form
          [parentFormGroup]="patchingItemForm"
          [itemBundle]="patchingItem.bundle"
          [itemBundleForm]="getPatchingItemFormControl('bundle')"
          [itemSiblings]="replacingItem.siblings">
        </eas-editor-booking-item-bundle-form>
      }
      @if (getPatchingItemFormArray('settings')) {
        <ng-container [formGroup]="patchingItemForm">
          <ng-container formGroupName="settings">
            @for (itemSetting of patchingItem.settings; track itemSetting; let itemSettingIndex = $index) {
              <eas-editor-booking-item-setting-form
                [itemSetting]="itemSetting"
                [parentItemSetting]="parentPatchingItem !== null ? parentPatchingItem.settings[itemSettingIndex] : null"
                [itemSettingForm]="getPatchingItemFormArrayFormGroup('settings', itemSettingIndex)">
              </eas-editor-booking-item-setting-form>
            }
          </ng-container>
        </ng-container>
      }
      @if (getPatchingItemFormArray('metadataList')) {
        <eas-editor-booking-item-metadata-list-form
          [parentFormGroup]="patchingItemForm"
          [itemMetadataList]="patchingItem.metadataList"
          [parentItemMetadataList]="parentPatchingItem !== null ? parentPatchingItem.metadataList : null"
          [itemMetadataListFormArray]="getPatchingItemFormArray('metadataList')"
          [newItemMetadataListFormArray]="getPatchingItemFormArray('newMetadataList')">
        </eas-editor-booking-item-metadata-list-form>
      }
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" i18n>Discard</button>
    <button mat-flat-button color="primary" [disabled]="patchingItemForm.invalid" (click)="onSubmit()" i18n>Apply</button>
  </mat-dialog-actions>
}
